<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    confirm-text="保存"
    :title="createForm.id?'修改抽奖配置' :'新增抽奖配置'"
    width="30%"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="100px"
      >
        <el-form-item
          label="奖品名称"
          prop="awardName"
        >
          <el-input v-model="createForm.awardName" />
        </el-form-item>
        <el-form-item
          label="优惠券"
          prop="productType"
        >
          <el-select
            v-model="createForm.awardCouponId"
            filterable
            clearable
            placeholder="请选择优惠券"
          >
            <el-option
              v-for="award in awardCouponList"
              :key="award.id"
              :label="award.couponName + '---' + award.discountFee / 100 + '元'"
              :value="award.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="奖品权重"
          prop="winWeight"
        >
          <el-input v-model="createForm.winWeight" />
        </el-form-item>
      </el-form>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';

export default {
  name: 'ProductDialog',
  components: { customeDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    return {
      cancelText: '取消',
      awardCouponList: [],
      createForm: {
        id: null,
        awardName: null,
        awardCouponId: '',
        winWeight: 1,
      },
      creatRules: {
        awardName: [
          { required: true, message: '请输入奖品名称', trigger: 'blur' },
        ],
        // awardCouponId: [
        //   { required: true, message: '请选择优惠券', trigger: 'change' },
        // ],
        winWeight: [
          {
            required: true, message: '请输入权重', trigger: 'blur',
          },
        ],
      },
    };
  },
  watch: {
    item: {
      handler(val) {
        this.$nextTick(() => {
          if (val) {
            const {
              awardName,
              winWeight,
              id,
            } = val;
            let { awardCouponId } = val;
            if (awardCouponId === -1) {
              awardCouponId = '';
            }
            this.createForm = {
              awardName,
              awardCouponId,
              winWeight,
              id,
            };
          }
        });
      },
      deep: true,
    },
  },
  mounted() {
    this.getAwardList();
  },
  methods: {
    close() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close');
      this.$refs.createForm.clearValidate();
      this.$refs.createForm.resetFields();
    },
    confirm() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          this.createForm.evaluationId = this.$route.params.id;
          if (this.createForm.awardCouponId === '') {
            this.createForm.awardCouponId = -1;
          }
          const data = await axClient.evaluation.evaluationAwardUpsert(this.createForm);
          if (!data) return;
          if (this.createForm.id) {
            this.$message.success('修改抽奖配置成功');
          } else {
            this.$message.success('新增抽奖配置成功');
          }
          this.$emit('update:dialogVisible', false);
          this.$emit('confirm');
          this.$refs.createForm.clearValidate();
          this.$refs.createForm.resetFields();
        }
      });
    },
    async getAwardList() {
      this.awardCouponList = await axClient.evaluation.couponList({ couponType: null });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: 200px;
}

</style>
